import axiosInstance from "@/lib/axiosInterceptor";
import { queryOptions } from "@tanstack/react-query";
import { Result } from "types/result";
import { FormatInfo } from "../types/FormatInfo";

export const QUERY_KEY = "formats-info";

export const getFormatInfos = async (): Promise<Result<FormatInfo>> => {
    try {
        const { data } = await axiosInstance.get<FormatInfo>(`${process.env.NEXT_PUBLIC_BE_URL}/formats/info`);
        return {
            data,
            error: null,
        };
    } catch (e: any) {
        return {
            data: null,
            error: {
                message: e.message,
            },
        };
    }
};

export const getFormatInfosOptions = () =>
    queryOptions({
        queryKey: [QUERY_KEY],
        queryFn: getFormatInfos,
        staleTime: Infinity,
        retry: 3,
    });
